import styles from '../styles/pages/WorkInProgress.module.css';
import { DeviceSpecificLayout } from 'components/Layout/DeviceSpecificLayout';
import { BrandPlaceholder } from 'components/BrandPlaceholder/BrandPlaceholder';

export const WorkInProgress = () => {
  const getContent = () => {
    return (
      <div className={styles.wrapper}>
        <BrandPlaceholder />
      </div>
    );
  };

  return <DeviceSpecificLayout>{getContent()}</DeviceSpecificLayout>;
};
